/* eslint-disable */

import Deferred from 'es6-deferred'
import d3 from './d3-3'

// import * as d3Alt from "d3";

export function RangeSetup() {
  // this.svg;
  // this.x;

  // Maybe useful in the future if we want to have default colors
  // var colors = ["#29ADFF", "#E040FB", "#FF5555"];

  //Alternative set of colors:
  // var colors = ["#2D00F8", "#29ADFF", "#FF5555"];

  this.create = function(settings) {
    this.divId = settings.el
    this.margin = settings.margin
    var parent = d3.select('#' + this.divId)

    // Add class to parent div so that our css selectors can be scoped
    parent.classed('range-chart', true)

    var bbox = parent.node().getBoundingClientRect()
    this.width = bbox.width - this.margin.left - this.margin.right
    this.height = bbox.height - this.margin.top - this.margin.bottom

    this.svg = parent
      .append('svg')
      .attr('overflow', 'visible')
      .attr('width', this.width + this.margin.left + this.margin.right)
      .attr('height', this.height + this.margin.top + this.margin.bottom)
      .append('g')
      .attr(
        'transform',
        'translate(' + this.margin.left + ',' + this.margin.top + ')'
      )

    this.svg
      .append('g')
      .attr('class', 'x_axis')
      .attr('font-family', 'GT-America-Mono')
      .attr('font-size', '16')
      .attr('transform', 'translate(0,' + (this.height - 1) + ')')

    this.svg.append('g').attr('class', 'y_axis')

    // Outline rect
    this.svg
      .append('rect')
      .attr('y', 0)
      .attr('width', this.width)
      .attr('height', this.height)
      .attr('stroke-width', 2)
      .attr('stroke', '#959595')
      .attr('fill', 'none')

    // Patient indicator
    this.svg
      .append('rect')
      .attr('id', 'indicator-rect')
      .attr('x', 0)
      .attr('y', 2) // Cover the graph edge
      .attr('width', 3)
      .attr('height', this.height - 3)
      .attr('rx', 2)
      .attr('ry', 2)
      .attr('stroke-width', 3)
      .attr('stroke', 'none')

    // Range rect
    this.svg
      .append('rect')
      .attr('id', 'range-rect')
      .attr('y', 0)
      .attr('width', this.width)
      .attr('height', this.height)
      .attr('stroke-width', 2)
      .attr('stroke', '#4D4D4F')
      .attr('fill', 'none')

    var deferred = new Deferred()
    deferred.resolve('resolved')
    return deferred
  }

  this.update = function(data) {
    const id = data.id || '??'
    this.ranges = data.ranges
    this.min = data.min
    this.max = data.max
    this.x = d3.scale.linear().range([0, this.width])

    // console.log(id, { min: this.min, max: this.max })

    this.x.domain([this.min, this.max])

    var xAxis = d3.svg
      .axis()
      .scale(this.x)
      .ticks(5)
      .orient('bottom')
      .tickSize(0)
      .tickPadding(20)

    this.svg
      .select('.x_axis')
      .call(xAxis)
      .select('.ticks')
      .remove()

    // Delete old range lines
    this.svg.selectAll('line').remove()

    _.each(this.ranges, range => {
      this.svg
        .append('line')
        .attr('x1', this.x(range.min))
        .attr('y1', 0)
        .attr('x2', this.x(range.min))
        .attr('y2', this.height)
        .attr('stroke-width', 2)
        .attr('stroke', '#959595')
        .attr('fill', '#ff0000')
        .moveToBack()
    })

    this.svg
      .select('#indicator-rect')
      .transition()
      .attr('x', this.x(data.value))
      .attr('fill', data.color)

    this.svg
      .select('#range-rect')
      .transition()
      .attr('x', this.x(data.selected.min))
      .attr('width', this.x(data.selected.max) - this.x(data.selected.min))
      .attr('stroke-width', 3)
      .attr('stroke', data.color)
  }

  this.randomValue = function() {
    var pos = Math.floor(this.random(0, this.ranges.length))
    var range = this.ranges[pos]

    var d = {
      value: this.random(range.min, range.max),
      interpretation: range.interpretation,
      ranges: this.ranges // Keep original ranges
    }
    this.update(d)
  }

  this.random = function(min, max) {
    return min + Math.random() * (max - min)
  }
}

d3.selection.prototype.moveToFront = function() {
  return this.each(function() {
    this.parentNode.appendChild(this)
  })
}

d3.selection.prototype.moveToBack = function() {
  return this.each(function() {
    var firstChild = this.parentNode.firstChild
    if (firstChild) {
      this.parentNode.insertBefore(this, firstChild)
    }
  })
}
